import React, { Component } from 'react';
import { Detector } from 'react-detect-offline';
import { onlineText, offlineText, specials, offlineClosing } from './texts';

const Link = ({text}) => {
	const config = specials[text] || {};
	const tempHref = `${window.location.origin}${window.location.pathname}?forward=${config.shortName}`;
	return (
		<Detector render={({online}) =>
			<a target="_blank" href={online ? config.href : tempHref}>{text}</a>
		}/>
	);
};

const formatSpecialText = text => {
	const config = specials[text] || {};

	switch (config.type) {
		case 'link':
			return <Link text={text} />;
		default:
		case 'bold':
			return <b>{text}</b>;
	}
};

const textToLine = text => {
	const startIndex = text.indexOf('[');

	if (startIndex === -1) return text;

	const endIndex = text.indexOf(']');

	const startText = text.substring(0, startIndex);
	const specialText = text.substring(startIndex + 1, endIndex);
	const endText = text.substring(endIndex + 1);

	return (
		<span>
			{startText}
			{formatSpecialText(specialText)}
			{textToLine(endText)}
		</span>
	);
};

const textToParagraphs = text => text
	.split('\n\n')
	.filter(Boolean) // remove empty lines
	.map((lineText, i) => {
		return <p key={i}>{textToLine(lineText)}</p>;
	});

const onlineParagraphs = textToParagraphs(onlineText);
const offlineParagraphs = textToParagraphs(offlineText);
const offlineClosingLine = textToLine(offlineClosing);

export default class App extends Component {
	constructor(props) {
		super(props);

		this.state = {
			returningOnline: false,
		};
	}

  renderApp = ({ online }) => {
		const {returningOnline} = this.state;
		if (online) {
			return (
				<div className="page online">
					<div className="header" />
					<div className="text">
						{onlineParagraphs}
						{returningOnline && <p><i>{offlineClosingLine}</i></p>}
					</div>
				</div>
			);
		} else {
			return (
				<div className="page offline">
					<div className="header" />
					<h1>Restore Your Attention</h1>
					<div className="text">
						{offlineParagraphs}
						<p><i>{offlineClosingLine}</i></p>
					</div>
				</div>
			);
		}
  }

	render() {
		return <Detector render={this.renderApp} onChange={this.handleOnlineChange}/>;
	}

	handleOnlineChange = online => {
		if (online) {
			this.setState({
				returningOnline: true,
			});
		}
	}
}



// WEBPACK FOOTER //
// ./src/App.js